import { LoadingBars, COLORS } from '@summer/ui-components';

const Loading = (props: any) => (
  <LoadingBars color={props.color || COLORS.azure} />
);

export default Loading;
